import React from 'react';
import { instanceOf } from 'prop-types';
import CATableRowItems from './CATableRowItems';

const CATableRow = ({
  data,
  onRowChecked,
  isAllChecked = false,
  selectAllClicked = false,
}) => {
  const _handleOnChange = row => {
    onRowChecked(row);
  };
  return data.map(item => {
    return (
      <CATableRowItems
        key={item.id}
        data={item}
        handleOnChange={_handleOnChange}
        selectAllClicked={selectAllClicked}
        isAllChecked={isAllChecked}
      />
    );
  });
};

CATableRow.propTypes = {
  data: instanceOf(Object).isRequired,
};

CATableRow.defaultProps = {
  data: null,
};

export default CATableRow;
